module.exports = __webpack_public_path__ + "img/event2412_1_2.b1ed6ce7.jpg";